export type EnvironmentType =
  | 'local'
  | 'dev'
  | 'reg'
  | 'preview'
  | 'staging'
  | 'prod';
